import { Routes } from '@angular/router';
import {
  AuthGuard,
  GENERAL_CONSTANTS,
  HowdenWithoutMenuLayoutComponent,
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  NotAuthorizedComponent
} from '@howdeniberia/core-front';
import { TeladocEventsPageComponent } from './features/teladoc-events/pages/teladoc-events-page/teladoc-events-page.component';
import { APP_ROLES } from './shared/constants';
import { TelesuscripcionAccessRoles } from './shared/models/api/teladoc/telesuscripcion-access-roles';

export const AppRoutes = [
  {
    path: '',
    component: HowdenWithoutMenuLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      isLayout: false,
      roles: [...APP_ROLES.ALL]
    },
    children: [
      {
        path: 'requests',
        component: TeladocEventsPageComponent,
        title: $localize`:@@app.route.main:Eventos Teladoc`
      },
      {
        path: 'manual',
        component: TeladocEventsPageComponent,
        title: $localize`:@@app.route.main:Eventos Teladoc`,
        data: {
          isLayout: false,
          roles: [
            TelesuscripcionAccessRoles.TELESUSCRIPCIONADMIN,
            TelesuscripcionAccessRoles.TELESUSCRIPCIONTECNIC
          ]
        }
      },
      {
        path: 'requests/client/:clientId',
        component: TeladocEventsPageComponent,
        title: $localize`:@@app.route.main:Eventos Teladoc`
      },
      {
        path: 'requests/proyect/:proyectId',
        component: TeladocEventsPageComponent,
        title: $localize`:@@app.route.main:Eventos Teladoc`
      },
      {
        path: 'request/:requestId',
        component: TeladocEventsPageComponent,
        title: $localize`:@@app.route.main:Eventos Teladoc`
      }
    ]
  },
  {
    path: GENERAL_CONSTANTS.NotAuthorizedUrl,
    title: $localize`:@@app.route.notauthorized: No autorizado`,
    component: NotAuthorizedComponent
  },
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  { path: '**', redirectTo: '404' }
] as Routes;
